<template>
    <input-field label="Create a Password"
                 placeholder="Type here"
                 is-password
                 :padding-classes="passingClasses"
                 :col-span="colSpan"
                 v-model="password"
                 @input="onInput">
        <template v-slot:hint
                  v-if="password">
            <div class="text-left text-weight-regular password-hint text-sm">
                <div :class="getPasswordRuleClass(validatePasswordLength)">
                    <el-icon class="mr-xs font-weight-bold text-sm"
                             :name="iconForValidation(validatePasswordLength)">
                    </el-icon>
                    12 characters long
                </div>
                <div :class="getPasswordRuleClass(validatePasswordCases)">
                    <el-icon class="mr-xs font-weight-bold text-sm"
                             :name="iconForValidation(validatePasswordCases)">
                    </el-icon>
                    Must contain upper and lower case letters
                </div>
                <div :class="getPasswordRuleClass(validatePasswordDigit)">
                    <el-icon class="mr-xs font-weight-bold text-sm"
                             :name="iconForValidation(validatePasswordDigit)">
                    </el-icon>
                    Include at least one numerical digit
                </div>
                <div :class="getPasswordRuleClass(validatePasswordSpecialCharacter)">
                    <el-icon class="mr-xs font-weight-bold text-sm"
                             :name="iconForValidation(validatePasswordSpecialCharacter)">
                    </el-icon>
                    Include at least one special character
                </div>
            </div>
        </template>
    </input-field>
</template>

<script>
export default {
    props: {
        value: String,
        minLength: {
            type: Number,
            default: 12
        },
        colSpan: {
            type: Number,
            default: 12
        },
        passingClasses: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            password: this.value || '',
        }
    },

    watch: {
        password(newVal) {
            this.$emit('input', newVal)
            this.$emit('valid', this.isValid)
        }
    },

    computed: {
        validatePasswordLength() {
            return this.password.length >= this.minLength
        },
        validatePasswordCases() {
            return /[a-z]/.test(this.password) && /[A-Z]/.test(this.password)
        },
        validatePasswordDigit() {
            return /\d/.test(this.password)
        },
        validatePasswordSpecialCharacter() {
            // has at least one special (punctuation or symbol), excludes letters/digits/spaces
            return /[^\p{L}\p{N}\s]/u.test(this.password)
        },
        isValid() {
            return this.validatePasswordLength && this.validatePasswordCases && this.validatePasswordDigit && this.validatePasswordSpecialCharacter
        }
    },

    methods: {
        getPasswordRuleClass(rule) {
            return rule ? 'text-green' : 'text-red'
        },
        iconForValidation(rule) {
            return rule ? 'check' : 'close'
        },
        onInput() {
            this.$emit('input', this.password)
            this.$emit('valid', this.isValid)
        }
    }
}
</script>
